<script>
  import Text from '@components/general/text.svelte'
  import Button from '@components/buttons/button.svelte'
  import Image from '@components/general/image.svelte'
  import Tag from '@components/general/tag.svelte'

  let { title = "Suggested Videos", videos = [] } = $props()

  $inspect(videos)
</script>

{#if videos.length > 0}
  <div class="flex flex-col gap-3 pb-5 border-b border-gray-200/80">
    
    <!-- The list title -->
    <Text variant="section_title" text={title} as="h5" />
    
    <!-- The list items -->
    {#each videos as video (video.id)}
      
    <!-- The list item container -->
      <Button variant="naked" 
        class="flex items-center gap-2 p-2 border border-solid border-transparent -mx-2 hover:border-primary-200 hover:bg-primary-50/80"
        path={`/videos/${video.id}`}>

        <!-- The list item image -->
        <Image src={video.vimeo_image_url} alt={video.name} width={100} height={100} class="w-10 h-10 object-cover" />

        <!-- The list item details -->
        <div class="flex flex-1 min-w-0 flex-col gap-1">
          
          <!-- The list item name -->
          <span class="w-full truncate text-gray-700 font-medium text-sm">{video.name}</span>

          <!-- The list item tags -->
          <div class="flex items-center gap-1">
            {#each video.tags as tag (tag.id)}
              <Tag {tag} size="xs" />
            {:else}
              <Tag tag={{ name: "Untagged", color: "gray" }} size="xs" />
            {/each}
          </div>
        </div>
      </Button>
    {/each}
  </div>
{/if}